<template>
<div class="page">
  <!-- 中断结束页面 -->
  <div class="early_end_page" v-if="status == 10013">
    <img src="@/assets/images/survey/early_end_page.png" alt="" class="early_end">
    <div v-if="integralCount > 0">
      <div class="txt_1">谢谢参与 答题所得积分已自动入账</div>
      <div class="txt_2">{{integralCount}}积分</div>
      <div @click="back" class="back_btn">返回首页</div>
    </div>
    <div v-else class="txt_con">
      <span style="color:#333;">非常抱歉，您被系统自动退出，原因可能是：</span>
      <span>1.不符合本次调研对象的要求。如是，请耐心等待下次调研，感谢您积极参与；</span>
      <span>2.系统自动检测出您填答时出现逻辑错误，或者没有专心认真填答。如是，请务必认真填答问卷。</span>
      <span style="margin-top:10px;">系统连续三次检出不认真填答，会自动屏蔽您接收问卷的功能。</span>
    </div>
  </div>
  <!-- 已参与过问卷页面 -->
  <div class="finish_page" v-if="status == 2">
    <img src="@/assets/images/survey/has_survey_page.png" alt="" class="early_end">
    <div class="txt">{{messageText}}</div>
  </div>
  <!-- 问卷停用页面 -->
  <div class="disable_page" v-if="status == 10005">
    <img src="@/assets/images/survey/disabled_page.png" alt="" class="disabled_img">
    <div class="txt">很抱歉，该问卷已停用</div>
  </div>
  <!-- 已填答过 -->
  <div class="submit_result_page" v-if="status == 10014">
    <img src="@/assets/images/survey/has_been_completed.png" alt="" class="has_been_completed">
    <div class="txt_1">问卷已完成</div>
    <div @click="back" class="back_btn big">返回首页</div>
  </div>
  <!-- 正常完成提交结果页面 -->
  <div class="submit_result_page" v-if="status == 6">
    <img src="@/assets/images/survey/finish_img.png" alt="" class="finish_img">
    <div class="txt_1">答卷所得现金积分已自动入账</div>
    <div class="txt_2">{{rewardAmount}}元现金 + {{integralCount}}积分</div>
    <div v-if="surveyShare" @click="share" class="btn">邀请好友成立专属调研团</div>
    <div @click="back" class="back_btn">返回首页</div>
  </div>
  <!-- 问卷已更新页面 -->
  <div class="disable_page" v-if="status == 5">
    <img src="@/assets/images/survey/update_page.png" alt="" class="disabled_img">
    <div class="txt">很抱歉，该问卷已被更新，您可退出后，从新作答。</div>
  </div>
</div>
</template>
<script>
export default {
  data () {
    return {
      status:'',               // 状态  10013：中断结束、2：已参与过调研  10005:停用  10014:已填答过   5:问卷已更新 6：正常完成提交
      messageText:'',          // 对应状态提示文本
      surveyShare:false,       // 是否能分享
      integralCount:'',        // 积分数
      rewardAmount:''          // 现金数
    }
  },
  components: {
  },
  created () {
    location.href = `zwapp://surveyCompleted`
    this.status = this.$route.query.status;
    this.messageText = this.$route.query.messageText;
    this.surveyShare = this.$route.query.surveyShare;
    this.integralCount = this.$route.query.integralCount ? this.$route.query.integralCount : '';
    this.rewardAmount = this.$route.query.rewardAmount ? this.$route.query.rewardAmount : '';
    console.log('integralCount:',this.integralCount,'rewardAmount:',this.rewardAmount);
  },
  mounted () {
  },
  computed:{
  },
  methods: {
    share(){
      let title = encodeURIComponent('快来加入我的调研团吧！一起发表观点赢奖励');
      let description = encodeURIComponent('注册参与，随时随地都有新问卷');
      let webpageUrl = encodeURIComponent(`https://dev.quickbusiness.cn/survey/downLoad`);
      let thumbDataUrl = encodeURIComponent('https://zhuowen.oss-cn-beijing.aliyuncs.com/dev/0/survey_info/16178520603606941.png');
      console.log(description,webpageUrl,thumbDataUrl);
      location.href=`zwapp://share?type=h5&title=${title}&description=${description}&webpageUrl=${webpageUrl}&thumbDataUrl=${thumbDataUrl}&needInviteCode=1`;
    },
    back(){
      location.href = `zwapp://goHome`
    }
  }
}
</script>
<style lang="less" scoped>
.page{
  .early_end_page,.finish_page{
    width: 100%;
    height: 100vh;
    background-color: #fff;
    .early_end{
      margin: 200px auto 0;
      width: 336px;
      height: 239px;
      display: block;
    }
    .txt_1{
      margin-top: 36px;
      font-size: 28px;
      line-height: 48px;
      color: #999999;
      text-align: center;
    }
    .txt_2{
      margin-top: 20px;
      font-size: 28px;
      line-height: 32px;
      color: #EB614B;
      font-weight: 600;
      text-align: center;
    }
    .back_btn{
      margin-top: 32px;
      font-size: 32px;
      line-height: 44px;
      color: #097BD2;
      text-align: center;
      font-weight: bold;
    }
    .txt{
      width: 400px;
      margin: 44px auto 0;
      font-size: 28px;
      line-height: 48px;
      color: #999999;
      text-align: center;
    }
    .txt_con{
      margin-top: 44px;
      padding: 0 60px;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      span{
        font-size: 28px;
        line-height: 48px;
        color: #999999;
        margin-bottom: 10px;
      }
    }
  }
  .disable_page{
    width: 100%;
    min-height: 100vh;
    background-color: #fff;
    .disabled_img{
      margin: 200px auto 0;
      width: 336px;
      height: 241px;
      display: block;
    }
    .txt{
      width: 400px;
      margin: 44px auto 0;
      font-size: 28px;
      line-height: 48px;
      color: #999999;
      text-align: center;
    }
  }
  .submit_result_page{
    width: 100%;
    min-height: 100vh;
    background-color: #fff;
    .finish_img{
      margin: 78px auto 0;
      width: 493px;
      height: 409px;
      display: block;
    }
    .has_been_completed{
      margin: 292px auto 0;
      width: 337px;
      height: 223px;
      display: block;
    }
    .txt_1{
      margin-top: 36px;
      font-size: 28px;
      line-height: 48px;
      color: #999999;
      text-align: center;
    }
    .txt_2{
      margin-top: 20px;
      font-size: 28px;
      line-height: 32px;
      color: #EB614B;
      font-weight: 600;
      text-align: center;
    }
    .btn{
      margin: 72px auto 0;
      width: 512px;
      height: 80px;
      font-size: 32px;
      line-height: 80px;
      text-align: center;
      color: #fff;
      background: #097bd2;
      border-radius: 48px;
    }
    .back_btn{
      margin-top: 32px;
      font-size: 32px;
      line-height: 44px;
      color: #097BD2;
      text-align: center;
      font-weight: bold;
      &.big{
        margin: 92px auto 0;
        width: 496px;
        height: 80px;
        background: #097bd2;
        border-radius: 48px;
        text-align: center;
        line-height: 80px;
        font-size: 32px;
        color: #FFFFFF;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/survey/statusPage.vue